import React from 'react';
import './SegmentedDistributionBar.scss';

export interface SegmentedDistributionBarSegment {
  id: string;
  label: string;
  value: number;
  color: string;
}

export interface SegmentedDistributionBarProps {
  segments: SegmentedDistributionBarSegment[];
  accessibleLabel: string;
  showSegmentValues?: boolean;
  compact?: boolean;
}

const formatValue = (value: number) => `${Number.isInteger(value) ? value : value.toFixed(1)}%`;

const SegmentedDistributionBar: React.FC<SegmentedDistributionBarProps> = ({
  segments,
  accessibleLabel,
  showSegmentValues = true,
  compact = false,
}) => {
  const visibleSegments = segments.filter((segment) => segment.value > 0);

  const rootClassName = [
    'segmented-distribution-bar',
    compact ? 'segmented-distribution-bar--compact' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={rootClassName}>
      <div className="segmented-distribution-bar__bar" role="img" aria-label={accessibleLabel}>
        {visibleSegments.map((segment) => (
          <div
            className={`segmented-distribution-bar__segment segmented-distribution-bar__segment--${segment.id}`}
            data-testid={`segmented-distribution-bar-segment-${segment.id}`}
            key={segment.id}
            style={{
              backgroundColor: segment.color,
              width: `${segment.value}%`,
            }}
            aria-hidden="true"
          />
        ))}
      </div>
      {showSegmentValues && visibleSegments.length > 0 ? (
        <div className="segmented-distribution-bar__values" aria-hidden="true">
          {visibleSegments.map((segment) => (
            <span
              className={`segmented-distribution-bar__value segmented-distribution-bar__value--${segment.id}`}
              data-testid={`segmented-distribution-bar-value-${segment.id}`}
              key={segment.id}
              style={{ color: segment.color }}
            >
              <span>
                <strong>{formatValue(segment.value)}</strong> {segment.label}
              </span>
            </span>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default SegmentedDistributionBar;
